export const SEARCH_THROUGH_DB = 'components/DBAutocomplete/SEARCH_THROUGH_DB';
export const CREATE_AUTOCOMPLETE = 'components/DBAutocomplete/CREATE_AUTOCOMPLETE';
export const REGISTER_AUTOCOMPLETE = 'components/DBAutocomplete/REGISTER_AUTOCOMPLETE';
export const UNREGISTER_AUTOCOMPLETE = 'components/DBAutocomplete/UNREGISTER_AUTOCOMPLETE';
export const SET_DATA_SOURCE = 'components/DBAutocomplete/SET_DATA_SOURCE';
export const SET_ORIGIN = 'components/DBAutocomplete/SET_ORIGIN';
export const UNREGISTER_ALL_AUTOCOMPLETES = 'components/DBAutocomplete/UNREGISTER_ALL_AUTOCOMPLETES';
export const SET_CHOSEN_TEXT = 'components/DBAutocomplete/SET_CHOSEN_TEXT';
export const SET_PRELOAD = 'components/DBAutocomplete/SET_PRELOAD';
export const OPTION_CHOSEN = 'components/DBAutocomplete/SET_PRELOAD';

export const DOES_NOT_EXIST = 'does_not_exist';
